<router-outlet>

</router-outlet>

<div bsModal #ConfirmLogoutModal="bs-modal" class="modal fade timeout-modal logout-modal" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static',keyboard:false}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"> {{'Messages.SessionAbouttToExpire' | translate}} </h4>
      </div>
      <div class="modal-body">
        <!--<div class="form-horizontal">-->
        <div class="form-group row ml-3 mr-3">
          <div class="col-md-12">
            <p>{{'Messages.SessionLockMessage' | translate}} {{timerCount}} {{'Messages.SessionDurationSecond' | translate}}.{{'Messages.Doyouwanttocontinue' | translate}}</p>
          </div>

        </div>
        <div class="form-group row" style="margin-bottom: 0rem !important">
          <div class="col-md-12">
            <div class="action modal-footer">
              <button type="button" class="btn btn-light" (click)="logout()">{{'Messages.NoLogout' | translate}}</button>
              <button type="button" class="btn btn-primary" (click)="keepWorking()">{{KeepWorkingButtonText | translate}}</button>
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
  </div>
</div>
</div>

<div bsModal #RefreshTokenFaildedModal="bs-modal" class="modal fade timeout-modal refreshtoken-failed-modal" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static',keyboard:false}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"> {{'Messages.RefreshTokenFailed' | translate}} </h4>
      </div>
      <div class="modal-body">
        <!--<div class="form-horizontal">-->
        <div class="form-group row ml-3 mr-3">
          <div class="col-md-12">
            @if (!hideKeepWorkingButton) {
              <p><b> {{'Messages.RefreshTokenFailedDesc'  | translate}} </b></p>
            }
            @if (!hideKeepWorkingButton) {
              <p>{{'Messages.SessionLockMessage' | translate}} {{refreshTokenFailedtimerCount}} {{'Messages.SessionDurationSecond' | translate}}.{{'Messages.Doyouwanttocontinue' | translate}}</p>
            }
            @if (hideKeepWorkingButton) {
              <p class="text-danger center">
                <b>
                  {{'Messages.SessionLogoutMessage' | translate}}
                </b>
              </p>
            }
          </div>

        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <div class="action modal-footer">
              <button type="button" class="btn btn-light" (click)="logout()">{{logOutButtonText| translate}}</button>
              @if (!hideKeepWorkingButton) {
                <button type="button" class="btn btn-primary" (click)="ManuallTokenRefresh()"> {{KeepWorkingButtonText | translate}}</button>
              }
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
  </div>
</div>
</div>
